import React, { createContext, useContext, useState, ReactNode, useMemo } from 'react';

interface FilterContextType {
  filters: Record<string, string | string[] | boolean | null>;
  setFilter: (key: string, value: string | string[] | boolean | null) => void;
  clearFilters: () => void;
  deleteFilter: (key: string) => void;
}

const FilterContext = createContext<FilterContextType | undefined>(undefined);

export const FilterContextProvider = ({ children }: { children: ReactNode }) => {
  const [filters, setFilters] = useState<Record<string, string | string[] | boolean | null>>({});

  const setFilter = (key: string, value: string | string[] | boolean | null) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const clearFilters = () => setFilters({});
  const deleteFilter = (key: string) => {
    setFilters((prev) => {
      const updatedFilters = { ...prev };
      delete updatedFilters[key];
      return updatedFilters;
    });
  };

  const FilterStore = useMemo(() => {
    return { filters, setFilter, clearFilters, deleteFilter };
  }, [filters, setFilter, clearFilters, deleteFilter]);

  return <FilterContext.Provider value={FilterStore}>{children}</FilterContext.Provider>;
};

export const useFilterContext = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error('useFilterContext must be used within a FilterProvider');
  }
  return context;
};
